import styled from 'styled-components';

import {AddressViewValuesMap} from '~/shared/consts/addressConsts';
import {body20Bold} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';
import {flexColumnCenterVertically} from '~/shared/theme/FlexLayout';

const TitleText = styled.label.attrs({
  tabIndex: 0,
})`
  ${body20Bold}
  ${flexColumnCenterVertically}
  flex: 1;
  text-align: center;
  color: ${({theme}) => theme.addressDropdown.form.titleColor};
  letter-spacing: 0.5px;
  position: absolute;
  background: ${({theme}) => theme.colors.surface};
  width: 100%;
  height: 100%;
`;

const textsConfigTranslationKeys = {
  [AddressViewValuesMap.ADD]: 'add_new_address',
  [AddressViewValuesMap.EDIT]: 'edit_address',
  [AddressViewValuesMap.EDIT_LOCAL]: 'edit_address',
  [AddressViewValuesMap.ADD_COMPANY_ADDRESS]: 'add_company_address',
};

const AddressTitleText = ({addressView}) => {
  const {t} = getLocalizationService();

  return (
    <>
      {addressView && addressView in textsConfigTranslationKeys && (
        <TitleText>{t(textsConfigTranslationKeys[addressView])}</TitleText>
      )}
    </>
  );
};

export default AddressTitleText;
